"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const babel = require("babel-core");
const callcc = require("./callcc");
const freeIds = require("./freeIds");
exports.freeIds = freeIds;
const generic = require("./generic");
exports.generic = generic;
const babylon = require("babylon");
var callcc_1 = require("./callcc");
exports.plugin = callcc_1.default;
var generic_1 = require("./generic");
exports.unreachable = generic_1.unreachable;
const hygiene = require("@stopify/hygiene");
const h = require("@stopify/util");
const visitor = {
    Program(path) {
        h.transformFromAst(path, [[hygiene.plugin, { reserved: [] }]]);
        h.transformFromAst(path, [callcc.default]);
        path.stop();
    }
};
function normalize(code) {
    let ast = babylon.parse(code);
    const result = babel.transformFromAst(ast.program, undefined, {
        babelrc: false,
        code: true,
        ast: false,
        plugins: [() => ({ visitor })]
    });
    return result.code;
}
exports.normalize = normalize;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi90cy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLG9DQUFvQztBQUNwQyxtQ0FBbUM7QUFDbkMscUNBQXFDO0FBSTVCLDBCQUFPO0FBSGhCLHFDQUFxQztBQUduQiwwQkFBTztBQUZ6QixtQ0FBbUM7QUFDbkMsbUNBQTZDO0FBQXBDLDBCQUFBLE9BQU8sQ0FBVTtBQUUxQixxQ0FBd0M7QUFBL0IsZ0NBQUEsV0FBVyxDQUFBO0FBQ3BCLDRDQUE0QztBQUM1QyxtQ0FBbUM7QUFHbkMsTUFBTSxPQUFPLEdBQWE7SUFDdEIsT0FBTyxDQUFDLElBQUk7UUFDUixDQUFDLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxFQUNuQixDQUFFLENBQUUsT0FBTyxDQUFDLE1BQU0sRUFBRyxFQUFFLFFBQVEsRUFBRSxFQUFFLEVBQUUsQ0FBRSxDQUFFLENBQUMsQ0FBQztRQUMvQyxDQUFDLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxFQUFFLENBQUUsTUFBTSxDQUFDLE9BQU8sQ0FBRSxDQUFDLENBQUM7UUFDN0MsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDO0lBQ2hCLENBQUM7Q0FDSixDQUFBO0FBRUQsU0FBZ0IsU0FBUyxDQUFDLElBQVk7SUFDbEMsSUFBSSxHQUFHLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM5QixNQUFNLE1BQU0sR0FBRyxLQUFLLENBQUMsZ0JBQWdCLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRSxTQUFTLEVBQUU7UUFDMUQsT0FBTyxFQUFFLEtBQUs7UUFDZCxJQUFJLEVBQUUsSUFBSTtRQUNWLEdBQUcsRUFBRSxLQUFLO1FBQ1YsT0FBTyxFQUFFLENBQUUsR0FBRyxFQUFFLENBQUMsQ0FBQyxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUU7S0FDbkMsQ0FBQyxDQUFDO0lBQ0gsT0FBTyxNQUFNLENBQUMsSUFBSyxDQUFDO0FBQ3hCLENBQUM7QUFURCw4QkFTQyJ9


//////////////////
// WEBPACK FOOTER
// ../normalize-js/dist/ts/index.js
// module id = 190
// module chunks = 0